// Format a patient's current room for display. `room` is the nested room object
// (viewPatientProfileData.room.room). An "expected" assignment means no real room
// yet, and a "waiting" assignment is shown as "Waiting Room". Returns "" when there
// is nothing to show so callers can supply their own empty fallback ("-", "Not
// assigned", etc.).
export const getRoomDisplayName = (room?: any): string => {
  if (!room) return "";
  if (room?.isExpectedRoom === true) return "No room assigned";
  if (room?.isWaitingRoom === true) return "Waiting Room";
  return `${room?.name}${room?.roomNumber ? ` (${room?.roomNumber})` : ""}`;
};
